module.exports = __webpack_public_path__ + "img/inventory Color.4db6aa00.svg";